import { j as json } from "../../../../../chunks/index2.js";
import { g as get, U as UserCollection } from "../../../../../chunks/firebase.js";
const GET = async ({ params, fetch }) => {
  const id = params.id;
  if (id) {
    const user = await get(UserCollection(), id);
    if (user.data) {
      if (Object.keys(user.data).length === 1) {
        await user.ref.delete();
      } else {
        return json(user.data);
      }
    }
    return fetch(`/api/users?email=${id}@glimmr.com`);
  }
  return json({ error: "No query provided" }, { status: 400 });
};
export {
  GET
};
